import * as React from "react";
import LabelledDataForm, { LabelledData } from "../label/LabelledDataForm";
import Avatar, { AvatarSize } from "../commons/components/user/Avatar";
import {
  PatientAndAccountInformation,
  PatientInformation,
} from "../commons/model/patient/PatientInfo";
import "./PatientCard.scss";
import { getLegalGuardianLabelledData } from "./PatientData";
import { InvitationConfiguration } from "./PatientAccountInviter";
import AccessToConvetedPatientProfileAction from "./AccessToPatientCardAction";
import ConvertLeadToPatientAction from "./ConvertLeadToPatientAction";

export default function PatientCard(props: {
  patient: PatientInformation;
  legalGuardians: PatientAndAccountInformation[];
  patientData: (
    patient: PatientInformation,
    isPatientView?: boolean,
    showLeadStatus?: boolean,
    isConvertedLead?: boolean
  ) => LabelledData[];
  patientFullDetailsURL?: string;
  invitationConfiguration?: InvitationConfiguration;
  isPatientView?: boolean;
  convertToPatientURL?: string;
  convertedPatientProfileURL?: string;
  showLeadStatus: boolean;
}) {
  return (
    <div className="patient-card">
      <Avatar
        size={AvatarSize.MEDIUM}
        userInfo={{
          avatarHref: props.patient.avatarHref,
          name: props.patient.fullName,
        }}
      />
      <LabelledDataForm
        data={props.patientData(
          props.patient,
          props.isPatientView,
          props.showLeadStatus,
          props.convertedPatientProfileURL !== null
        )}
      />
      <LegalGuardianSection
        patientContactInfoUid={props.patient.contactInfoUid}
        legalGuardians={props.legalGuardians}
        invitationConfiguration={props.invitationConfiguration}
      />
      {props.patientFullDetailsURL && (
        <div className="v-flex centered action-full-details">
          <a className="button-secondary small" href={props.patientFullDetailsURL}>
            <i className="ic_external_link" />
            <span>{i18n["Page.PatientManagement.GetFullDetails"]}</span>
          </a>
        </div>
      )}
      {props.convertToPatientURL && !props.convertedPatientProfileURL && (
        <div className="v-flex centered action-convert-to-patient">
          <ConvertLeadToPatientAction url={props.convertToPatientURL} />
        </div>
      )}
      {props.convertedPatientProfileURL && (
        <div className="v-flex centered action-convert-to-patient">
          <AccessToConvetedPatientProfileAction url={props.convertedPatientProfileURL} />
        </div>
      )}
    </div>
  );
}

function LegalGuardianSection({
  patientContactInfoUid,
  legalGuardians,
  invitationConfiguration,
}: {
  patientContactInfoUid: string;
  legalGuardians: PatientAndAccountInformation[];
  invitationConfiguration?: InvitationConfiguration;
}) {
  return (
    <>
      {legalGuardians.map((guardian) => (
        <React.Fragment key={guardian.contactInfoUid}>
          <div className="panel-subtitle">
            {i18n["Page.PatientManagement.Profile.LegalGuardian.Title"]}
          </div>
          <LabelledDataForm
            data={getLegalGuardianLabelledData(
              guardian,
              patientContactInfoUid,
              invitationConfiguration
            )}
          />
        </React.Fragment>
      ))}
    </>
  );
}
